import { useEffect, useRef, useState } from 'react';

export default function Gallery() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isVisible) {
            setIsVisible(true);
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: '0px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [isVisible]);

  return (
    <section 
      id="gallery" 
      className="py-32 relative overflow-hidden"
      style={{
        background: 'linear-gradient(180deg, #0A1A2F 0%, #11243F 100%)'
      }}
    >
      <div 
        ref={sectionRef}
        className={`max-w-7xl mx-auto px-6 transition-all duration-[1500ms] ease-out relative z-10 ${
          isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-110'
        }`}
      >
        <div className="text-center mb-16">
          <div className="w-16 h-0.5 bg-luxury-blue mx-auto mb-6"></div>
          <h3 className="text-4xl font-light text-white mb-8 tracking-tight">
            施工実績（現在準備中）
          </h3>
          <div className="max-w-3xl mx-auto space-y-6">
            <p className="text-base text-gray-300 leading-relaxed font-light">
              Garage de car care は、2026年の本格オープンに向けて準備を進めています。
            </p>
            <p className="text-base text-gray-300 leading-relaxed font-light">
              現在はテスト施工・モニター施工を中心に経験を積んでおり、<br />
              公開できる実績が揃い次第こちらで掲載していきます。
            </p>
            <p className="text-base text-gray-300 leading-relaxed font-light">
              1台1台、納得のいく仕上がりにこだわりながら、<br />
              少しずつ実績ページを育てていきますので、もうしばらくお待ちください。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
